module.exports = __webpack_public_path__ + "static/media/20210411_144705_285_IMG_0445.dbe125c7.jpg";